module.exports = __webpack_public_path__ + "img/tit-cn.38103dce.svg";